import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

export interface ChangeLog {
  username: string;
  message: string;
  customer: string;
  date: string;
}

@Component({
  selector: "app-changes-log",
  templateUrl: "./changes-log.component.html",
  styleUrls: ["./changes-log.component.scss"],
})
export class ChangesLogComponent {
  logs: ChangeLog[] = [];

  constructor(private dialogRef: MatDialogRef<ChangesLogComponent>) {
    this.logs = [
      {
        username: "Ahmed Hassan",
        message: "Created new order",
        customer: "Cairo Hospital",
        date: "2026-02-18 10:15 AM",
      },
      {
        username: "Tamer Elmorsi",
        message: "Updated customer phone number",
        customer: "Alex Clinic",
        date: "2026-02-18 12:40 PM",
      },
      {
        username: "Sara Mohamed",
        message: "Deleted invoice item",
        customer: "Giza Medical Center",
        date: "2026-02-19 09:05 AM",
      },
    ];
  }

  close(): void {
    this.dialogRef.close();
  }
}
